import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { AddBrandAPI } from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import Style from "./AddBrandContainer.module.scss";
const AddBrandContainer = () => {
  const [loadingBtn, setLoadingBtn] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onsubmit = (data) => {
    setLoadingBtn(true);
    let info = {
      brand_persian: data.brand_persian,
      brand_english: data.brand_english,
      file: "",
    };
    AddBrandAPI(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setLoadingBtn(false);
      } else {
        errorToast(succ.message);
        setLoadingBtn(false);
      }
    });
  };
  return (
    <div className={Style.ComponentHolder}>
      <TableFixedPage title={"افزودن برند"} />
      <div className={Style.imgHolder}>
        <img src="/Assets/Images/assignProduct/restaurant.svg" alt="" />
      </div>
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <input
          className={errors.price ? Style.errorInput : Style.inputPart}
          placeholder={"نام برند به فارسی"}
          {...register("brand_persian", { required: true })}
        />
        <input
          className={errors.price ? Style.errorInput : Style.inputPart}
          placeholder={"نام برند به انگلیسی"}
          {...register("brand_english", { required: true })}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <button className={Style.btnStyle} type={"submit"}>
            {loadingBtn ? (
              <Spinner animation="border" variant="light" />
            ) : (
              "ثبت"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddBrandContainer;
